import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/intogo/solution_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={816}
              height={862}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#76CE51" }}>Solution</span>
            </h2>
            <p>
              Into Go is powered with vibrant colors, local categories and lots
              of features. No Into Go user will ever miss out on events, fun
              places to visit, adventures and other exciting activities and
              experiences that may interest them. Into Go helps you explore your
              city unlike ever before.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
